import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDataMtmShow } from '../../../../stores/algos-list/actions';
import { getIsMtmShow } from '../../../../stores/algos-list/getters';
import CellToggleHide from './CellToggleHide';

const MtmHideButton = () => {
  const dispatch = useDispatch();
  const show = useSelector(getIsMtmShow);

  const onToggle = () => {
    dispatch(toggleDataMtmShow());
  };

  return <CellToggleHide show={show} onToggle={onToggle} />;
};

export default MtmHideButton;
